import { render, staticRenderFns } from "./precision-editor.vue?vue&type=template&id=4c08300e&scoped=true"
import script from "./precision-editor.vue?vue&type=script&lang=js"
export * from "./precision-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c08300e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c08300e')) {
      api.createRecord('4c08300e', component.options)
    } else {
      api.reload('4c08300e', component.options)
    }
    module.hot.accept("./precision-editor.vue?vue&type=template&id=4c08300e&scoped=true", function () {
      api.rerender('4c08300e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/precision-editor.vue"
export default component.exports